import { render, staticRenderFns } from "./bimAffProgramm.vue?vue&type=template&id=109467d1&scoped=true&"
import script from "./bimAffProgramm.vue?vue&type=script&lang=js&"
export * from "./bimAffProgramm.vue?vue&type=script&lang=js&"
import style0 from "./bimAffProgramm.vue?vue&type=style&index=0&id=109467d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109467d1",
  null
  
)

export default component.exports